import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { AuthService, BaseSiteService, LanguageService } from '@spartacus/core';
import { CommonCdcEnabelService } from '../../../../features/services/common-cdcEnabled.service';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
  selector: 'app-header-links',
  templateUrl: './header-links.component.html',
  styleUrls: ['./header-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderLinksOutletComponent implements OnInit {
  private authService = inject(AuthService);
  private baseSiteService = inject(BaseSiteService);
  private commonCdcService = inject(CommonCdcEnabelService);
  private activeCartService = inject(ActiveCartService);
  private languageService = inject(LanguageService);
  private environmentService = inject(EnvironmentService);
  private destroyRef = inject(DestroyRef);

  // Signals for reactive state
  isLoggedIn = toSignal(this.authService.isUserLoggedIn(), { initialValue: false });
  cart = toSignal(this.activeCartService.getActive());
  cdcEnabled = toSignal(this.commonCdcService.cdcEnabled$, { initialValue: false });
  languages = toSignal(this.languageService.getAll(), { initialValue: [] });
  activeLang = toSignal(this.languageService.getActive(), { initialValue: '' });

  private activeSite = toSignal(this.baseSiteService.getActive(), { initialValue: '' });

  // Feature flags as signals
  showAddToCartButtonAndCartMenuNode = signal(false);
  showMyAccountDropdown = signal(false);
  showOrderHistoryMenuNode = signal(false);
  showLufcMembershipMenuNode = signal(false);
  subscriptions = signal(false);
  showLanguageSelectorDropdown = signal(false);

  // Computed signals
  lufcMembershipUrl = computed(() => {
    const active = this.activeSite();
    return active === 'hisense-uk' ? '/lufcoffers' : '/lufc-registration';
  });

  // isMobileSubmenuOpen = toSignal(
  //   this.submenuStateService.openMenuItemUid$.pipe(map((uid) => uid !== null && uid !== undefined)),
  //   { initialValue: false }
  // );

  languagesCount = computed(() => this.languages()?.length ?? 0);

  cartItemCount = computed(() => this.cart()?.deliveryItemsQuantity ?? 0);

  ngOnInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((active) => {
        const env = this.environmentService.getCurrentEnvironment();
        this.showAddToCartButtonAndCartMenuNode.set(env.eShop.showAddToCartButtonAndCartMenuNode[active]);
        this.showMyAccountDropdown.set(env.eShop.showMyAccountDropdown[active]);
        this.showOrderHistoryMenuNode.set(env.eShop.showOrderHistoryMenuNode[active]);
        this.showLufcMembershipMenuNode.set(env.eShop.showLufcMembershipMenuNode[active]);
        this.subscriptions.set(env.subscriptions[active]);
        this.showLanguageSelectorDropdown.set(env.showLanguageSelectorDropdown[active]);
      });
  }

  setLanguage(lang: string | undefined): void {
    if (lang) {
      this.languageService.setActive(lang);
    }
  }
}
